"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CContentFeatured = exports.EContentPaneFormat = void 0;
var types_1 = require("../types");
var EContentPaneFormat;
(function (EContentPaneFormat) {
  EContentPaneFormat["banner-invite"] = "banner-invite";
  EContentPaneFormat["banner-subject"] = "banner-subject";
  /** Блок - дисциплины для /lessons */
  EContentPaneFormat["subjects"] = "subjects";
  /** Блок - категории (типы) контента для /lessons */
  EContentPaneFormat["categories"] = "categories";
  /** Карточка контента на всю ширину страницы с деталями */
  EContentPaneFormat["card-full"] = "card-full";
  /** Карточка контента на всю ширину страницы с деталями + мета данные для отдельной страницы контента */
  EContentPaneFormat["card-full-main"] = "card-full-main";
  EContentPaneFormat["card-mid"] = "card-mid";
  EContentPaneFormat["card-mini"] = "card-mini";
  EContentPaneFormat["card-micro"] = "card-micro";
  EContentPaneFormat["card-universal"] = "card-universal";
  EContentPaneFormat["gallery"] = "gallery";
  /** Преподаватель дня */
  EContentPaneFormat["teacher-of-the-day"] = "teacher-of-the-day";
  EContentPaneFormat["meetings"] = "meetings";
  /** Горизонтальный блок с прокруткой "Преподаватели" */
  EContentPaneFormat["teachers"] = "teachers";
  EContentPaneFormat["exercises"] = "exercises";
  /** Блок - "вернуться на уровень назад" */
  EContentPaneFormat["goback"] = "goback";
  EContentPaneFormat["recent"] = "recent";
  /** Горизонтальный блок с прокруткой "Недавно добавленные" */
  EContentPaneFormat["last-created"] = "last-created";
  /** Горизонтальный блок с прокруткой "Недавно просмотренные" */
  EContentPaneFormat["last-viewed"] = "last-viewed";
  /** Горизонтальный блок с прокруткой "Недавно просмотренные" */
  EContentPaneFormat["popular"] = "popular";
  /** Урок дня */
  EContentPaneFormat["lesson-of-the-day"] = "lesson-of-the-day";
  EContentPaneFormat["informer-stats"] = "informer-stats";
  EContentPaneFormat["welcome"] = "welcome";
  EContentPaneFormat["get-started-widget"] = "get-started-widget";
  EContentPaneFormat["teachers-drag-scroll"] = "teachers-drag-scroll";
  /** Виджет - оставьте отзыв об уроке */
  EContentPaneFormat["review-suggest"] = "review-suggest";
  /** Виджет - поделись ссылкой на урок */
  EContentPaneFormat["share-link-widget"] = "share-link-widget";
  /** Горизонтальный блок с прокруткой для сервисов */
  EContentPaneFormat["user-services-drag-scroll"] = "user-services-drag-scroll";
  /** Блок - колонка из карточек преподавателей в разделе /teachers */
  EContentPaneFormat["teachers_column"] = "teachers_column";
  /** Блок - блок с набором выбранных фильтров с возможностью сброса */
  EContentPaneFormat["filter-cleaning"] = "filter-cleaning";
  /** Блок - хлебные крошки */
  EContentPaneFormat["bread-crumbs"] = "bread-crumbs";
  /** Блок - отзывы о митингах */
  EContentPaneFormat["meetings-reviews"] = "meetings-reviews";
  /** Горизонтальный блок с прокруткой "Коллекции" */
  EContentPaneFormat["collections-drag-scroll"] = "collections-drag-scroll";
  /** Виджет - для обучающих вебинаров */
  EContentPaneFormat["webinar-widget"] = "webinar-widget";
  /** Блок основных страниц */
  EContentPaneFormat["base-pages"] = "base-pages";
  /** Блок каруселей с митингами */
  EContentPaneFormat["meetings-stack"] = "meetings-stack";
  /** Блок каруселей с сервисами */
  EContentPaneFormat["user-services-stack"] = "user-services-stack";
  /** Блок - колонка из карточек школ в разделе /schools */
  EContentPaneFormat["schools-column"] = "schools-column";
  /** Блок - расписание */
  EContentPaneFormat["my-classes-schedule"] = "my-classes-schedule";
  /** Блок - репетиторы */
  EContentPaneFormat["my-classes-tutors"] = "my-classes-tutors";
  /** Блок - классные комнаты */
  EContentPaneFormat["my-classes-classrooms"] = "my-classes-classrooms";
  /** Блок - домашняя работа */
  EContentPaneFormat["my-classes-homework"] = "my-classes-homework";
  /** Блок - студенты */
  EContentPaneFormat["my-classes-students"] = "my-classes-students";
  /** Блок - школы */
  EContentPaneFormat["my-classes-schools"] = "my-classes-schools";
  /** Блок - контент */
  EContentPaneFormat["my-library-content"] = "my-library-content";
  /** Блок - услуги */
  EContentPaneFormat["my-library-services"] = "my-library-services";
  /** Блок - коллекции */
  EContentPaneFormat["my-library-collections"] = "my-library-collections";
  /** Блок - курсы */
  EContentPaneFormat["my-library-courses"] = "my-library-courses";
  /** Блок - комментарии*/
  EContentPaneFormat["comments"] = "comments";
  /** Блок - новости людей */
  EContentPaneFormat["people-news"] = "people-news";
  /** Блок - новости классных комнат*/
  EContentPaneFormat["classroom-news"] = "classroom-news";
  /** Блок - новости школ*/
  EContentPaneFormat["schools-news"] = "schools-news";
  /** Блок - активность в уроках*/
  EContentPaneFormat["activity-lesson"] = "activity-lesson";
  /** Блок - активность с коллекциями*/
  EContentPaneFormat["activity-collections"] = "activity-collections";
  /** Блок - активность с услугами*/
  EContentPaneFormat["activity-services"] = "activity-services";
  /** Блок - избранное с уроками*/
  EContentPaneFormat["favorites-lessons"] = "favorites-lessons";
  /** Блок - избранное с услугами*/
  EContentPaneFormat["favorites-services"] = "favorites-services";
  /** Блок - избранное с репетиторами*/
  EContentPaneFormat["favorites-tutors"] = "favorites-tutors";
  /** Блок - избранное с коллекциями*/
  EContentPaneFormat["favorites-collections"] = "favorites-collections";
  /** Блок - избранное с пользователями*/
  EContentPaneFormat["favorites-users"] = "favorites-users";
  /** Блок - избранные школы*/
  EContentPaneFormat["favorites-schools"] = "favorites-schools";
  /** Виджет - Первое знакомство*/
  EContentPaneFormat["widget-welcome"] = "widget-welcome";
  /** Виджет - Фильтр*/
  EContentPaneFormat["widget-filter"] = "widget-filter";
  /** Виджет - Популярные митинги*/
  EContentPaneFormat["widget-popular-meetings"] = "widget-popular-meetings";
  /** Виджет - Популярные уроки*/
  EContentPaneFormat["widget-popular-lessons"] = "widget-popular-lessons";
  /** Виджет - Популярные teachers*/
  EContentPaneFormat["widget-popular-tutors"] = "widget-popular-tutors";
  /** Виджет - онбординг*/
  EContentPaneFormat["widget-onboarding"] = "widget-onboarding";
  /** Виджет - Новости*/
  EContentPaneFormat["widget-news"] = "widget-news";
  /** Новая карточка - сетка */
  EContentPaneFormat["new-grid-universal-card"] = "new-grid-universal-card";
  /** Новая карточка для уроков */
  EContentPaneFormat["new-exercises"] = "new-exercises";
  /** Новый простой заголовок */
  EContentPaneFormat["new-simple-title"] = "new-simple-title";
  /** Новый простой заголовок */
  EContentPaneFormat["new-teachers-column"] = "new-teachers-column";
})(EContentPaneFormat = exports.EContentPaneFormat || (exports.EContentPaneFormat = {}));
var CContentFeatured = /** @class */function (_super) {
  __extends(CContentFeatured, _super);
  function CContentFeatured(values) {
    if (values === void 0) {
      values = {
        panes: [],
        conditions: {}
      };
    }
    return _super.call(this, values) || this;
  }
  CContentFeatured.selectClosestConditions = function () {
    //
  };
  return CContentFeatured;
}(types_1.Assignable);
exports.CContentFeatured = CContentFeatured;
